/**
 * Откладывает выполнение функции до окончания задержки после последнего вызова.
 * Опционально функция может быть вызвана сразу при первом вызове.
 *
 * @param {Function} func - Функция для отложенного вызова.
 * @param {number} wait - Время задержки в миллисекундах.
 * @param {boolean} [immediate=false] - Если true, функция вызывается сразу при первом вызове.
 * @returns {Function} Функция, которая будет вызвана после задержки или немедленно.
 *
 * @example
 * // Пример использования для ограничения частоты вызова функции при изменении размера окна.
 * window.addEventListener('resize', debounce(handleResize, 250));
 *
 * @example
 * // Пример немедленного вызова функции при клике, последующие клики игнорируются до истечения 500 мс.
 * loginButton.addEventListener('click', debounce(sendLoginRequest, 500, true));
 */
export function debounce(func, wait, immediate, funcBeforeDebounce = null) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (funcBeforeDebounce) funcBeforeDebounce.apply(context, args);
    if (callNow) func.apply(context, args);
  };
}

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text).then(
    function () {},
    function (err) {
      alert('Failed to copy: ', err);
    }
  );
}

export function copyToClipboardTimer(elem, text) {
  let timeoutId = null;

  // Функция для копирования текста
  const copyText = () => {
    navigator.clipboard.writeText(text).then(
      () => {},
      (err) => {
        alert('Ошибка при копировании: ' + err);
      }
    );
  };

  // Функция для обработки нажатия кнопки
  const handleMouseDown = () => {
    // Устанавливаем таймер на 1500 миллисекунд
    timeoutId = setTimeout(copyText, 1500);
  };

  // Функция для обработки отпускания кнопки
  const handleMouseUp = () => {
    // Очищаем таймер, если кнопка отпущена раньше времени
    clearTimeout(timeoutId);
  };

  // Привязка событий к элементу кнопки
  elem.addEventListener('mousedown', handleMouseDown);
  elem.addEventListener('mouseup', handleMouseUp);
  elem.addEventListener('mouseleave', handleMouseUp); // Добавляем обработчик на случай, если курсор покинет кнопку
}

export function throttle(func, limit, useTimeout = true) {
  let lastFunc;
  let lastRan;

  return function (...args) {
    const context = this;
    const now = Date.now();

    if (useTimeout) {
      // Стандартное поведение с таймаутом
      if (!lastRan) {
        func.apply(context, args); // Немедленный вызов при первом запуске
        lastRan = now;
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (now - lastRan >= limit) {
            func.apply(context, args); // Вызов после задержки
            lastRan = now;
          }
        }, Math.max(limit - (now - lastRan), 0));
      }
    } else {
      // Версия без таймаута: вызов мгновенный, если интервал прошел
      if (!lastRan || now - lastRan >= limit) {
        func.apply(context, args); // Немедленный вызов
        lastRan = now; // Обновляем время последнего вызова
      }
    }
  };
}
